import { ProjectType } from '@api';
import { ProjectsTable } from '@features';
import { Box } from '@mantine/core';

type FinanceOverviewPagePropsType = {
  projects: ProjectType[];
  isPending: boolean;
};

export const FinanceOverviewPage: React.FC<FinanceOverviewPagePropsType> = ({
  projects,
  isPending,
}) => {
  return (
    <Box py="md">
      <ProjectsTable projects={projects} isPending={isPending} />
    </Box>
  );
};
